import Resizer from 'react-image-file-resizer'

export const fileHelper = {
  getSourceFile,
  resizeFile,
}

function getSourceFile(file, cb) {
  const reader = new FileReader()
  reader.onloadend = () => {
    cb(reader.result)
  }
  reader.readAsDataURL(file)
}

function resizeFile({ file, type = 'PNG', quality = 50 }) {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      2048,
      2048,
      type,
      quality,
      0,
      (uri) => {
        resolve(uri)
      },
      'base64'
    )
  })
}
